import { Card, Row, Col, Tooltip } from "antd";
import moment from "moment";
import React, { Component } from 'react';

class Edits extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        let edits = this.props.edits;
        console.log("eec",edits)

        return (
            <div>
                <Card className="pr-2 pb-2 mb-2 pl-3">
                    <div className="userDetails">
                        <div className="attachmentTableDiv">
                            <table className="attachmentTable summaryTable">
                                <thead>
                                    <tr>
                                        <th>Sl #</th>
                                        <th>Line #</th>
                                        <th>Edit #</th>
                                        <th>Description</th>
                                        <th>Workaround</th>
                                        <th>Resolution</th>
                                        <th>Status</th>
                                        <th>Category</th>
                                        <th>Added By</th>
                                        <th>Overriden By</th>
                                    </tr>
                                </thead>
                                <tbody className="tableBody">
                                    {
                                        edits.map((item, index) => {
                                            var serialNumber;
                                            if (index <= 9) {
                                                serialNumber = '0' + (index + 1);
                                            } else {
                                                serialNumber = index + 1;
                                            }
                                            return (
                                                <tr>
                                                    <td>{serialNumber}</td>
                                                    <Tooltip placement="top" title={`${!item.line_Id ? "------" : item.line_Id}`}>
                                                        <td>{!item.line_Id ? "------" : item.line_Id}</td>
                                                    </Tooltip>
                                                    <Tooltip placement="top" title={`${!item.edit_ID ? "------" : item.edit_ID}`}>
                                                        <td>{!item.edit_ID ? "------" : item.edit_ID}</td>
                                                    </Tooltip>
                                                    <Tooltip placement="top" title={`${!item.description ? "------" : item.description}`}>
                                                        <td>{!item.description ? "------" : item.description}</td>
                                                    </Tooltip>
                                                    <Tooltip placement="top" title={`${!item.workAround ? "------" : item.workAround}`}>
                                                        <td>{!item.workAround ? "------" : item.workAround}</td>
                                                    </Tooltip>
                                                    <Tooltip placement="top" title={`${!item.resolution ? "------" : item.resolution}`}>
                                                        <td>{!item.resolution ? "------" : item.resolution}</td>
                                                    </Tooltip>
                                                    <Tooltip placement="top" title={`${!item.status ? "------" : item.status}`}>
                                                        <td>{!item.status ? "------" : item.status}</td>
                                                    </Tooltip>
                                                    <Tooltip placement="top" title={`${!item.category ? "------" : item.category}`}>
                                                        <td>{!item.category ? "------" : item.category}</td>
                                                    </Tooltip>
                                                    <Tooltip placement="top" title={`${!item.addedBy ? "------" : item.addedBy}`}>
                                                        <td>{!item.addedBy ? "------" : item.addedBy}</td>
                                                    </Tooltip>
                                                    <Tooltip placement="top" title={`${!item.overrideBy ? "------" : item.overrideBy}`}>
                                                        <td>{!item.overrideBy ? "------" : item.overrideBy}</td>
                                                    </Tooltip>
                                                </tr>
                                            )
                                        })
                                    }

                                </tbody>
                            </table>
                        </div>
                    </div>
                </Card>
            </div>
        );
    }
}

export default Edits;